import { Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import {
  LayoutDashboard,
  Users,
  DollarSign,
  TrendingUp,
  Shield,
  Settings,
  LogOut,
} from 'lucide-react';

export function AdminNavigation() {
  const { profile, signOut } = useAuthStore();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const navItems = [
    {
      label: 'Dashboard',
      path: '/admin/dashboard',
      icon: LayoutDashboard,
    },
    {
      label: 'Users',
      path: '/admin/users',
      icon: Users,
    },
    {
      label: 'Financials',
      path: '/admin/financials',
      icon: DollarSign,
    },
    {
      label: 'Analytics',
      path: '/admin/analytics',
      icon: TrendingUp,
    },
    {
      label: 'Settings',
      path: '/admin/settings',
      icon: Settings,
    },
  ];

  const handleSignOut = async () => {
    await signOut();
    window.location.href = '/login';
  };

  return (
    <div className="bg-gray-900 text-white min-h-screen w-64 fixed left-0 top-0 flex flex-col">
      <div className="p-6 border-b border-gray-700">
        <div className="flex items-center gap-3 mb-2">
          <Shield className="w-8 h-8 text-blue-400" />
          <h1 className="text-xl font-bold">Admin Panel</h1>
        </div>
        <p className="text-sm text-gray-400">{profile?.full_name}</p>
      </div>

      <nav className="flex-1 py-6">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex items-center gap-3 px-6 py-3 transition ${
              isActive(item.path)
                ? 'bg-blue-600 text-white border-l-4 border-blue-400'
                : 'text-gray-300 hover:bg-gray-800 hover:text-white'
            }`}
          >
            <item.icon className="w-5 h-5" />
            <span className="font-semibold">{item.label}</span>
          </Link>
        ))}
      </nav>

      <div className="p-6 border-t border-gray-700">
        <Link
          to="/"
          className="block px-4 py-2 mb-2 bg-gray-800 rounded-lg text-center hover:bg-gray-700 transition text-sm"
        >
          View Site
        </Link>
        <button
          onClick={handleSignOut}
          className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-red-600 rounded-lg hover:bg-red-700 transition text-sm font-semibold"
        >
          <LogOut className="w-4 h-4" />
          Sign Out
        </button>
      </div>
    </div>
  );
}
